
import { ElementRef, Injectable } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { IndexExpense } from './index-expense';
import { responseRemoveExpense } from './http/res/response-remove-expense';
import { Category } from './category/category';
import { showEditMode } from './info-expense/show-edit-mode';
import { CreateNewProduct } from './broadcaster/info-expense/create-new-product';
import { responseAddExpense } from './http/res/response-add-expense';
import { CategoryDirectory } from './directory/category';
import { TableData } from './table-data';
import { DealerShip } from './dealer-ship';
import { Rooftop } from '../app/class/rooftop';
@Injectable()
export class LeftMenu {
    positionMouse = { x: 0, y: 0 };
    constructor(private elRef: ElementRef,private broadcaster: Broadcaster) {



    }
    /*  public ClosedCreateProduct() {
  
          this.elRef.nativeElement.querySelector('#tags').value = "";
          this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left h3').style.display = 'inline-block';
          this.elRef.nativeElement.querySelector('#edit-product-have-name').style.display = 'none';
          this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left input').style.display = 'none';
          this.elRef.nativeElement.querySelector('#edit-product-not-name').style.display = 'table-cell';
          this.elRef.nativeElement.querySelector('#add-product').checked = true;
          this.elRef.nativeElement.querySelector('.table_control-edit-choose').style.display = 'none';
          this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left p').style.display = 'none';
      }*/
    public setPositionMouse(x: number, y: number) {
        this.positionMouse.x = x;
        this.positionMouse.y = y;
    }
    public getPositionMouse() {
        return { x: this.positionMouse.x, y: this.positionMouse.y }
    }
    public getCordCategories(cat: any) {
        let categories = cat;
        let cordCatefories = [];
        for (let i = 0; i < categories.length; i++) {
            let elem = this.elRef.nativeElement.querySelector(`.tc__menu_item[data-line=${categories[i].id}]`);
            if (elem.classList.contains('m--hidden')) {
                cordCatefories.push({ top: this.getCoords(elem).top, left: this.getCoords(elem).left, id: categories[i].id });
            }

        }
        return cordCatefories;
    }
    public getCoords(elem) { // кроме IE8-
        var box = elem.getBoundingClientRect();

        return {
            top: box.top + pageYOffset,
            left: box.left + pageXOffset
        };

    }
    public closedAllAddProduct() {
        let list = this.elRef.nativeElement.querySelectorAll('.add-product');
        for (let i = 0; i < list.length; i++) {
            let parent = list[i].querySelector('.add-product-hit');
            parent.querySelector('input').style.display = 'none';
            parent.querySelector('span').style.display = 'block';
            parent.querySelector('button').style.display = 'none';
            parent.querySelector('.closed').style.display = 'none';
        }
    }
    public ToggleLabels() {

        if (window.localStorage.getItem('graphStatus') && Number(window.localStorage.getItem('graphStatus')) === 0) {
            this.elRef.nativeElement.querySelector('.labels').style.display = 'none';

            document.body.querySelector('.left-main').classList.add('scroll-fixed-left-without-graph');
            if (window.pageYOffset < 80) {
                document.body.querySelector('.left-main').classList.add('scroll-fixed-left-without-graph-start');
            }
            /* if (window.localStorage.getItem('viewCompactStatus')) {
                 let switchViewGraph: boolean = (Number(window.localStorage.getItem('viewCompactStatus')) === 0 ? true : false);
                 if (switchViewGraph) {
 
                 }
             }*/
         


        }
    }
  
    public CloseCategori() {
        (<HTMLElement>document.body.querySelector('.add-categori-body')).style.display = 'none';
        (<HTMLElement>this.elRef.nativeElement.querySelector('.add-categori-hit span')).style.display = 'block';
        (<HTMLElement>this.elRef.nativeElement.querySelector('.add-categori-hit input')).style.display = 'none';
        (<HTMLElement>this.elRef.nativeElement.querySelector('.add-categori-icon')).style.display = 'none';
        (<HTMLElement>this.elRef.nativeElement.querySelector('.add-categori')).classList.remove('active-add-categoti');
        (<HTMLElement>this.elRef.nativeElement.querySelector('.paint-bucket')).style.display = 'none';
        (<HTMLElement>this.elRef.nativeElement.querySelector('.add-categori-hit .plus')).style.display = 'block';
        this.broadcaster.broadcast('ClosedAddCategory');

    }
    /* public defaultMenu() {
            console.log("defaultMenu");
            let item = $(".tc__menu_item");
            for (let u = 0; u < item.length; u++) {
                if (!item[u].classList.contains('m--hidden')) {
                    item[u].classList.add('m--hidden');
                    item[u].querySelector(".menu-line").style.height = "102px";
                    // item[u].querySelector(".tc__edit__cat").style.top = 'calc(50% - 8px)';
                    item[u].querySelector('.parent-title span').style.color =
                        "#262626";
                    item[u].querySelector('.parent-price span').style.color =
                        "#262626";
                    item[u].querySelector('.parent-price span').style.fontSize =
                        "18px";
                    item[u].querySelector('.parent-price p').style.fontSize =
                        "18px";
                    item[u].querySelector('.parent-title span').style.fontSize =
                        "18px";
                    item[u].querySelector('.parent-price').style.color =
                        "#a6a6a6";
    
                }
    
            }
    
            $(".tc__submenu_item,.tc__subsubmenu_item").css({ display: "none" });
        }*/
    public defaultMenu() {

        let item = this.elRef.nativeElement.querySelectorAll('.tc__menu_item');
        for (let u = 0; u < item.length; u++) {
            if (!item[u].classList.contains('m--hidden')) {
                item[u].classList.add('m--hidden');
                item[u].querySelector(".menu-line").style.height = "102px";
                item[u].querySelector('.parent-title span').style.color =
                    "#262626";
                item[u].querySelector('.parent-price span').style.color =
                    "#262626";
                item[u].querySelector('.parent-price span').style.fontSize =
                    "18px";
                item[u].querySelector('.parent-price p').style.fontSize =
                    "18px";
                let parent_title = item[u].querySelectorAll('.parent-title span');
                for (let i = 0; i < parent_title.length; i++) {
                    parent_title[i].style.fontSize =
                        "18px";
                }
                item[u].querySelector('.parent-price').style.color =
                    "#a6a6a6";
            }
        }
        let tc__submenu_item = this.elRef.nativeElement.getElementsByClassName('tc__submenu_item');
        for (let u = 0; u < tc__submenu_item.length; u++) {
            tc__submenu_item[u].style.display = 'none';
        }
        let tc__subsubmenu_item = this.elRef.nativeElement.getElementsByClassName('tc__subsubmenu_item');
        for (let s = 0; s < tc__subsubmenu_item.length; s++) {
            tc__subsubmenu_item[s].style.display = 'none';
        }
    }
    getDateString(data: any): string {

        return `${data.year}-${(data.month < 10) ? '0' + data.month : data.month}-${(data.day < 10) ? '0' + data.day : data.day}`
    }

    public createProduct(cat: Array<Category>, data: CreateNewProduct, res: responseAddExpense, list: Array<CategoryDirectory>): any {
        let categories: Array<Category> = cat;
        let dataProduct: CreateNewProduct = data;
        let response: responseAddExpense = res;
        let ListProducts: Array<CategoryDirectory> = list;
        let catIndex = categories.findIndex(element => element.id.split('categories-').join('') === String(dataProduct.expense.productCategoryId));
        let productIndex = 0;

        let updateCat = false;
        if (catIndex === (-1)) {
            updateCat = false;
        }
        else {
            productIndex = categories[catIndex].products.findIndex(element => element.id.split('products-').join('') === String(dataProduct.data.productId));
            if (productIndex === (-1)) {
                updateCat = true;
            }

        }

        if (updateCat) {
            let g = ListProducts.findIndex(element => String(element.productCategoryId) === String(response.category.id).split('categories-').join(''));
            for (let i = 0; i < response.category.products.length; i++) {
                let u = ListProducts[g].products.findIndex(element => String(element.productId) === String(response.category.products[i].id).split('products-').join(''));
                if (u === (-1)) {
                    response.category.products[i].ordinal = parseInt(dataProduct.data.ordinal);
                }
                else {
                    response.category.products[i].ordinal = parseInt(ListProducts[g].products[u].ordinal);
                }
            }
            response.category.products.sort(function (a, b) {
                return a.ordinal - b.ordinal;
            });
            response.category.open = categories[catIndex].open;
            categories[catIndex] = response.category;

        }
        else {
            let g = ListProducts.findIndex(element => String(element.productCategoryId) === String(response.category.id).split('categories-').join(''));
            for (let i = 0; i < response.category.products.length; i++) {
                let u = ListProducts[g].products.findIndex(element => String(element.productId) === String(response.category.products[i].id).split('products-').join(''));
                if (u === (-1)) {
                    response.category.products[i].ordinal = parseInt(dataProduct.data.ordinal);
                }
                else {
                    response.category.products[i].ordinal = parseInt(ListProducts[g].products[u].ordinal);
                }
            }
            response.category.ordinal = ListProducts[g].ordinal;

            categories.push(response.category);
            categories.sort(function (a, b) {
                return a.ordinal - b.ordinal;
            });

        }
        return categories;
    }
    public getParentElement(p, clas: string) {
        let parent = p;
        while (!parent.classList.contains(clas)) {

            parent = parent.parentNode;
            //  console.log("parent", parent);
        }
        return parent;
    }
    private getOffsetRect(elem) {
        var box = elem.getBoundingClientRect()
        var body = document.body
        var docElem = document.documentElement
        var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
        var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft
        var clientTop = docElem.clientTop || body.clientTop || 0
        var clientLeft = docElem.clientLeft || body.clientLeft || 0
        var top = box.top + scrollTop - clientTop
        var left = box.left + scrollLeft - clientLeft

        return { top: Math.round(top), left: Math.round(left) }
    }
    private getOffsetSum(elem) {
        var top = 0, left = 0
        while (elem) {
            top = top + parseFloat(elem.offsetTop)
            left = left + parseFloat(elem.offsetLeft)
            elem = elem.offsetParent
        }

        return { top: Math.round(top), left: Math.round(left) }
    }

    public getOffset(elem) {

        if (elem.getBoundingClientRect) {
            return this.getOffsetRect(elem)

        } else {
            return this.getOffsetSum(elem)

        }

    }

    /* public updateExpense(res: any, cat: any): any {
         let data: any = res;
         let categories: any = cat;
         let newFlightDate = [];
         console.log("data", data);
         for (let i = 0; i < data.expense.flightDate.length; i++) {
             newFlightDate.push({
                 start: this.getDateString(data.expense.flightDate[i].start), end: this.getDateString(data.expense.flightDate[i].end),
                 targetBudget: data.expense.flightDate[i].targetBudget
             });
 
         }
         if (data.dataId.g !== (-1)) {
             categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].title = data.expense.campaign;
             categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].expenses[0].flightDate = newFlightDate;
             if (categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price > data.expense.targetBudget) {
                 categories[data.dataId.i].products[data.dataId.u].price -= (categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price - data.expense.targetBudget);
                 categories[data.dataId.i].price -= (categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price - data.expense.targetBudget);
                 // categories[data.dataId.i].priceText = this.leftMenu.getPrice(categories[data.dataId.i].price);
             }
             if (categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price < data.expense.targetBudget) {
                 categories[data.dataId.i].products[data.dataId.u].price += (data.expense.targetBudget - categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price);
                 categories[data.dataId.i].price += (data.expense.targetBudget - categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price);
                 // categories[data.dataId.i].priceText = this.leftMenu.getPrice(categories[data.dataId.i].price);
             }
 
             categories[data.dataId.i].products[data.dataId.u].subproducts[data.dataId.g].price = data.expense.targetBudget;
         }
         else {
             if (categories[data.dataId.i].products[data.dataId.u].price > data.expense.targetBudget) {
                 categories[data.dataId.i].price -= (categories[data.dataId.i].products[data.dataId.u].price - data.expense.targetBudget);
             }
             if (categories[data.dataId.i].products[data.dataId.u].price < data.expense.targetBudget) {
                 categories[data.dataId.i].price += (data.expense.targetBudget - categories[data.dataId.i].products[data.dataId.u].price);
             }
             categories[data.dataId.i].products[data.dataId.u].price = data.expense.targetBudget;
             categories[data.dataId.i].products[data.dataId.u].expenses[0].flightDate = newFlightDate;
         }
         return categories;
     }*/
    public updateExpense(category: any, dataId: any, cat: any): any {
        let categories: any = cat;
        let categoryOut: any = category;
        for (let i = 0; i < categoryOut.products.length; i++) {
            let g = categories[dataId.i].products.findIndex(element => String(element.id).split('products-').join('') === String(categoryOut.products[i].id));
            if (g !== (-1)) {
                categoryOut.products[i].ordinal = parseInt(categories[dataId.i].products[g].ordinal);
            }

        }
        categoryOut.open = categories[dataId.i].open;
        categoryOut.products.sort(function (a, b) {
            return a.ordinal - b.ordinal;
        });
        return categoryOut;

    }
    /* public addCampaign(category: any, dataId: any, cat: any): any {
         let categories: any = cat;
         let categoryOut: any = category;
         for (let i = 0; i < categoryOut.products.length; i++) {
             let g = categories[dataId.i].products.findIndex(element => String(element.id).split('products-').join('') === String(categoryOut.products[i].id));
             if (g !== (-1)) {
                 categoryOut.products[i].ordinal = parseInt(categories[dataId.i].products[g].ordinal);
             }
 
         }
         categoryOut.products.sort(function (a, b) {
             return a.ordinal - b.ordinal;
         });
         return categoryOut;
 
     }*/
    public addProduct(cat: any, list: any, res: any): any {
        let categories: any = cat;
        let ListProducts: any = list;
        let category: any = res;
        let catIndex: number = categories.findIndex(element => String(element.id).split('categories-').join('') === String(category.id));
        let updateCat = false;
        if (catIndex === (-1)) {
            catIndex = ListProducts.findIndex(element => String(element.productCategoryId) === String(category.id));
            updateCat = false;
        }
        else {
            updateCat = true;
            let g = ListProducts.findIndex(element => String(element.productCategoryId) === String(category.id));
            for (let i = 0; i < category.products.length; i++) {
                let u = ListProducts[g].products.findIndex(element => String(element.productId) === String(category.products[i].id));

                category.products[i].ordinal = parseInt(ListProducts[g].products[u].ordinal);
            }
            category.products.sort(function (a, b) {
                return a.ordinal - b.ordinal;
            });
            category.open = categories[catIndex].open;
            categories[catIndex] = category;

        }
        if (!updateCat) {
            category.ordinal = ListProducts[catIndex].ordinal;

            categories.push(category);
            categories.sort(function (a, b) {
                return a.ordinal - b.ordinal;
            });
        }
        // this.elRef.nativeElement.querySelector('#tags').value = "";
        return categories;
    }

    public showEditExpense(broadcaster: any, res: any, indexProduct: number, catIndex: number, updateCat: boolean, categories: any = null) {
        if (updateCat) {
            broadcaster.broadcast('showEditMode',new showEditMode ({
                action: "edit-product",
                product: res.data.category.products[indexProduct],
                productsLen: res.data.category.products.length,
                dataId: new IndexExpense(catIndex,indexProduct,-1)
            }));
        }
        else {
            broadcaster.broadcast('showEditMode', new showEditMode ( {
                action: "edit-product",
                product: categories[catIndex].products[0],
                productsLen: 1,
                dataId: new IndexExpense(catIndex,0,-1)
            }));
        }

    }
    public checkRightsMediaCategory(right: any, tableData: TableData): boolean {
       
        for (let i = 0; i < right.budgetDealerGroups.length; i++) {
            if (right.budgetDealerGroups[i].dealerGroupId === tableData.settings.dealerGroupId && right.budgetDealerGroups[i].canManageMediaCategories === 1) {
                return false;
            }
        }
        return true;
    }
    public getMediaCategories(list: any):Array<String> {
        let mediaCategories = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].isMedia === 1) {
                mediaCategories.push(String(list[i].productCategoryId));
            }
        }
        return mediaCategories;

    }
    public setColorCategories(ListProducts: any, dealerGroupId: number) {
        let ColorCategories: any = (window.localStorage.getItem('colors')) ? JSON.parse(window.localStorage.getItem('colors')) : { list: [] };
        ColorCategories.list = [];
        for (let u = 0; u < ListProducts.length; u++) {
            ColorCategories.list.push({ client: String(dealerGroupId), id: String(ListProducts[u].productCategoryId), color: ListProducts[u].color });
        }
        window.localStorage.setItem('colors', JSON.stringify(ColorCategories));

    }
    public UpdateColorCategories(categories: any, ListProducts: any, dealerGroupId: string): any {

        let Outcategories: any = categories;
        let dealerShipIdList: any = JSON.parse(window.localStorage.getItem('dealerShipId'));
        let indexDealer: number = dealerShipIdList.list.findIndex(element => Number(element.client) === Number(dealerGroupId));
        let ColorCategories: any = (window.localStorage.getItem('colors')) ? JSON.parse(window.localStorage.getItem('colors')) : { list: [] };
        for (let u = 0; u < ListProducts.length; u++) {
            let index: number = Outcategories.findIndex(element => String(element.id).split('categories-').join('') === String(ListProducts[u].productCategoryId));
            if (index !== (-1)) {
                Outcategories[index].color = ListProducts[u].color;
                let indexColor: number = ColorCategories.list.findIndex(element => element.id === String(Outcategories[index].id).split('categories-').join('') && element.client === String(dealerGroupId));
                if (indexColor !== (-1)) {
                    ColorCategories.list[indexColor].color = ListProducts[u].color;
                }
                else {
                    ColorCategories.list.push({ client: String(dealerGroupId), id: String(Outcategories[index].id).split('categories-').join(''), rooftop: String(dealerShipIdList.list[indexDealer].id), color: ListProducts[u].color });
                }
            }
            else {
                let indexColorList: number = ColorCategories.list.findIndex(element => element.id === String(ListProducts[u].productCategoryId) && element.client === String(dealerGroupId));
                if (indexColorList === (-1)) {
                    ColorCategories.list.push({ client: String(dealerGroupId), id: String(ListProducts[u].productCategoryId), color: ListProducts[u].color });
                }

            }
        }
        window.localStorage.setItem('colors', JSON.stringify(ColorCategories));
        return Outcategories;
    }
    public checkProduct(NewProduct: any, categories: any) {
        let catIndex: number = 0;
        let productIndex: number = 0;
        catIndex = categories.findIndex(element => element.title === NewProduct.select);
        if (catIndex !== (-1)) {
            productIndex = categories[catIndex].products.findIndex(element => element.title === NewProduct.name);
            if (productIndex !== (-1)) {
                return true;
            }
        }
        return false;
    }
   /* public getListCategories(ListProducts: any, categories: any): any {
        let list = [];
        let priductHave: number = 0;
        console.log("categories", categories);
        for (let i = 0; i < ListProducts.length; i++) {
            let g: number = categories.findIndex(element => String(element.id).split('categories-').join('') === String(ListProducts[i].productCategoryId) || element.title.indexOf(ListProducts[i].name) === 0);
            if (g === (-1)) {
                list.push(ListProducts[i].name);
            }
        }
        return list;

    }*/
    /*  public UpdateAutoComplete(ListProducts: any, categories: any): any {
          let availableTags = [];
          let priductHave: number = 0;
          for (let i = 0; i < ListProducts.length; i++) {
              let g: number = categories.findIndex(element => String(element.id).split('categories-').join('') === String(ListProducts[i].productCategoryId) || element.title.indexOf(ListProducts[i].name) === 0);
              for (let u = 0; u < ListProducts[i].products.length; u++) {
                  if (g === (-1)) {
                      availableTags.push({
                          label: ListProducts[i].products[u].name, category: ListProducts[i].name
                      })
                  }
                  else {
  
                      priductHave = categories[g].products.findIndex(element => String(element.id).split('products-').join('') === String(ListProducts[i].products[u].productId) || element.title.indexOf(ListProducts[i].products[u].name) === 0);
                      if (priductHave === (-1)) {
                          availableTags.push({
                              label: ListProducts[i].products[u].name, category: ListProducts[i].name
                          })
                      }
  
                  }
  
              }
          }
          return availableTags;
      }*/
    public UpdateAutoComplete(ListProducts: any, categori: any): any {
        let availableTags = [];
        let priductHave: number = 0;

        let g: number = ListProducts.findIndex(element => String(element.productCategoryId) === String(categori.id).split('categories-').join(''));
        //  console.log("g", g);
        //   console.log("categori.id", categori.id);
        if (g === (-1)) return availableTags;
        for (let u = 0; u < ListProducts[g].products.length; u++) {
            priductHave = categori.products.findIndex(element => String(element.id).split('products-').join('') === String(ListProducts[g].products[u].productId) || element.title.indexOf(ListProducts[g].products[u].name) === 0);
            if (priductHave === (-1)) {
                availableTags.push({
                    label: ListProducts[g].products[u].name, category: ListProducts[g].name
                })
            }
        }

        return availableTags;
    }
    public setTextAddProductModal(body: any, buttonText: string, selectedList: boolean, title: string) {
        let outBody: any = body;
        outBody.buttonText = buttonText;
        outBody.selectedList = selectedList;
        outBody.title = title;
        return outBody;
    }
    public enabledAddProduct(event) {
        event.target.style.display = 'none';
        this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left p').style.display = 'inline-block';
        this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left input').style.display = 'inline-block';
        this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left input').focus();
        this.elRef.nativeElement.querySelector('#edit-product-have-name').style.display = 'table-cell';
        this.elRef.nativeElement.querySelector('#edit-product-not-name').style.display = 'none';
        this.elRef.nativeElement.querySelector('.table_control-edit-pannel-left').classList.add('table_control-edit-enabled');

    }
    public defaultStyles() {
      
        let rows: any = document.querySelectorAll(".main_table__row");
        for (let u = 0; u < rows.length; u++) {
            if (rows[u].querySelectorAll(".table_object_container").length !== 0) {

                rows[u].style.display = 'none';
            }
            if (rows[u].querySelectorAll(".table_categories").length !== 0) {
                if (!rows[u].classList.contains("m--hidden")) {
                    rows[u].classList.add("m--hidden");
                    let table_categories = rows[u].querySelectorAll(".table_categories");
                    for (let i = 0; i < table_categories.length; i++) {
                        table_categories[i].style.display = 'block'
                    }

                }
            }
            if (rows[u].querySelectorAll(".table_object_container").length === 0 && rows[u].querySelectorAll(".table_categories").length === 0) {
                if (!rows[u].classList.contains("js-table-days")) {
                    rows[u].style.display = 'none';
                }

            }
        }
        let table_object_product: any = document.querySelectorAll('.table_object_product');
        for (let s = 0; s < table_object_product.length; s++) {
            table_object_product[s].style.display = 'none'
        }

    }
    /*  public defaultStyles() {
  
          let rows = $(".main_table__row");
          for (let u = 0; u < rows.length; u++) {
              if ($(rows[u]).find(".table_object_container").length !== 0) {
                  $(rows[u]).css({ display: "none" });
              }
              if ($(rows[u]).find(".table_categories").length !== 0) {
                  if (!$(rows[u]).hasClass("m--hidden")) {
                      $(rows[u]).addClass("m--hidden");
                      $(rows[u]).find(".table_categories").css({ display: "block" });
                  }
              }
              if ($(rows[u]).find(".table_object_container").length === 0 && $(rows[u]).find(".table_categories").length === 0) {
                  if (!$(rows[u]).hasClass("js-table-days")) {
                      $(rows[u]).css({ display: "none" });
                  }
  
              }
          }
          $(".table_object_product").css({ display: "none" });
      }*/
    public getPrice(x: number): string {
        if (x > 100000) {
            let newX: number = Math.round(x / 1000);
            let parts = String(newX).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".") + "K";
        }
        else {
            let parts = String(x).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }
    }

    public findGetParamRooftop(rooftops: Array<Rooftop>, select: string, dealerGroupId: Number):number {

        if (select === undefined) {
            if (window.localStorage.getItem('dealerShipId') !== null) {
                let dealerShipId: DealerShip = JSON.parse(window.localStorage.getItem('dealerShipId'));
                let index: number = dealerShipId.list.findIndex(element => Number(element.client) === dealerGroupId);
                if (index !== (-1)) {
                    return Number(dealerShipId.list[index].id);
                }
            }
            else {
                let dealerShipIdList: DealerShip =  new DealerShip(dealerGroupId,rooftops[0].id);
                window.localStorage.setItem('dealerShipId', JSON.stringify(dealerShipIdList));
            }
        }
        else {
            let index = rooftops.findIndex(element => String(element.id) === select);
            if (index !== (-1)) {
                return Number(rooftops[index].id);
            }
        }
        return Number(rooftops[0].id)

    }
    /*public sortExpense(expenses: any, list: any, cat_id: string, prod_id: string): any {
        let out_expenses: any = expenses;
        let catIndex: number = list.findIndex(element => String(element.productCategoryId) === String(cat_id).split('categories-').join(''));
        let prodIndex: number = list[catIndex].products.findIndex(element => String(element.productId) === String(prod_id).split('products-').join(''));
        for (let i = 0; i < out_products.length; i++) {
            let g = list[catIndex].products.findIndex(element => String(element.productId) === String(out_products[i].id).split('products-').join(''));
            console.log("g", g);
            out_products[i].ordinal = parseInt(list[catIndex].products[g].ordinal);
        }
        out_products.sort(function (a, b) {
            return a.ordinal - b.ordinal;
        });
      
        return out_products;
    }*/
    public sortProduct(products: any, list: any, id: string): any {
        let out_products: any = products;
        let catIndex: number = list.findIndex(element => String(element.productCategoryId) === String(id).split('categories-').join(''));
        for (let i = 0; i < out_products.length; i++) {
            let g = list[catIndex].products.findIndex(element => String(element.productId) === String(out_products[i].id).split('products-').join(''));
           
            out_products[i].ordinal = parseInt(list[catIndex].products[g].ordinal);
        }
        out_products.sort(function (a, b) {
            return a.ordinal - b.ordinal;
        });
       
        return out_products;
    }
    public sortCategory(cat: any, list: any): any {
        let categories: any = cat;
        for (let i = 0; i < categories.length; i++) {
            let g = list.findIndex(element => String(element.productCategoryId) === String(categories[i].id).split('categories-').join(''));

            categories[i].ordinal = parseInt(list[g].ordinal);
        }
        categories.sort(function (a, b) {
            return a.ordinal - b.ordinal;
        });
        this.defaultMenu();
        this.defaultStyles();
        return categories;
    }
    public removeExpense(indexs: IndexExpense, cat: Array<Category>, res: responseRemoveExpense): any {
        let updateTable: boolean = false;
        let data: IndexExpense = indexs;
        let categories: Array<Category> = cat;

        let response: responseRemoveExpense = res;
        if (data.g !== undefined && data.g === (-1)) {
            if (categories[data.i].products.length > 1) {
                categories[data.i].price -= categories[data.i].products[data.u].price;
                categories[data.i].priceText = this.getPrice(categories[data.i].price);
                categories[data.i].products.splice(data.u, 1);
                updateTable = true;

            }
            else {
                categories.splice(data.i, 1);
               // this.defaultMenu();
              //  this.defaultStyles();
                updateTable = true;

            }
        }
        else {
            if (categories[data.i].products[data.u].subproducts.length > 1) {
                categories[data.i].products[data.u].price -= categories[data.i].products[data.u].subproducts[data.g].price;
                categories[data.i].products[data.u].priceText = this.getPrice(categories[data.i].products[data.u].price);
                categories[data.i].price -= categories[data.i].products[data.u].subproducts[data.g].price;
                categories[data.i].priceText = this.getPrice(categories[data.i].price);
                categories[data.i].products[data.u].subproducts.splice(data.g, 1);
                updateTable = true;
            }
            else {
                if (categories[data.i].products.length > 1) {
                    categories[data.i].price -= categories[data.i].products[data.u].price;
                    categories[data.i].priceText = this.getPrice(categories[data.i].price);
                    categories[data.i].products.splice(data.u, 1);
                    updateTable = true;
                }
                else {
                 //   categories[data.i] = response.category;
                    this.defaultMenu();
                    this.defaultStyles();
                    updateTable = false;

                }

            }
        }
        return {
            categories: categories,

            updateTable: updateTable
        }
    }
    public convertSubProductInProduct(list: any, res: any): any {
        let response: any = res;
        let ListProducts: any = list;
        let g = ListProducts.findIndex(element => String(element.productCategoryId) === String(response.data.category.id).split('categories-').join(''));
        for (let i = 0; i < response.data.category.products.length; i++) {
            for (let u = 0; u < ListProducts[g].products.length; u++) {
                if (String(response.data.category.products[i].id).split('products-').join('') === String(ListProducts[g].products[u].productId)) {
                    response.data.category.products[i].ordinal = parseInt(ListProducts[g].products[u].ordinal);
                }

            }
        }
        response.data.category.open = true;
        response.data.category.products.sort(function (a, b) {
            return a.ordinal - b.ordinal;
        });
        return response.data.category;
    }
    public removeProduct(cat: any, res: any): any {
        let categories: any = cat;
        let data: any = res;

        if (categories[data.data.i].products.length > 1) {
            categories[data.data.i].price -= categories[data.data.i].products[data.data.u].price;
            categories[data.data.i].priceText = this.getPrice(categories[data.data.i].price);
            categories[data.data.i].products.splice(data.data.u, 1);
        }
        else {
            categories.splice(data.data.i, 1);
        }
        return {
            categories: categories,

        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/class/leftmenu.service.ts